module.exports = __webpack_public_path__ + "static/img/Frame 1010104487@2x.4425cc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/pc/Frame 1010104487@2x.png
// module id = nSz6
// module chunks = 1